import { PaletteColor, Theme } from "@mui/material/styles";

// The theme does define `success[200]` (Figma "Primary/50"), but the type for it
// lives in web-shared-next's own overrides, which this project does not load.
export const getSuccess200 = (theme: Theme) =>
  (theme.palette.success as PaletteColor & { 200: string })[200];
